import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { ExternalIntegrationSelectProps } from './ExternalIntegrationSelect'
import { ExternalIntegrationSelect } from './ExternalIntegrationSelect'
import { Spinner } from 'common/Spinner/Spinner'

type ConnectedExternalIntegrationsSelectProps = Omit<ExternalIntegrationSelectProps, 'externalIntegrations'> & {
  provider?: string
  readOnly?: boolean
  onOpenIntegrations?: () => void
}

export const ConnectedExternalIntegrationsSelect = ({
  provider,
  onOpenIntegrations,
  ...props
}: ConnectedExternalIntegrationsSelectProps) => {
  const { data, isLoading } = useExternalIntegrations()
  const filteredExternalIntegrations =
    data?.external_integrations.filter((integration) => integration.provider === provider) || []

  if (isLoading) return <Spinner />

  return (
    <ExternalIntegrationSelect
      externalIntegrations={filteredExternalIntegrations}
      onOpenIntegrations={onOpenIntegrations}
      {...props}
    />
  )
}
